module.exports = __webpack_public_path__ + "img/6.871a783d.jpg";